import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import Button from 'shared/components/button/Button';
import NumberFormatField from 'shared/components/numberFormatField/NumberFormatField';

const GoalNutritionAdd = ({ setModalOpen, openModal, errors, setFieldValue, goal, values, setFieldTouched }) => {
  const fieldsNames = ['calories', 'carbs', 'fat', 'protein', 'water'];

  const makeFieldsTouched = () => {
    setFieldTouched('calories');
    setFieldTouched('carbs');
    setFieldTouched('fat');
    setFieldTouched('protein');
    setFieldTouched('water');
  }
  return (
    <div>
      <Modal isOpen={openModal} className="goal-add-modal">
        <ModalHeader>
          <span>Add Nutrition Goal</span>
          <a className="modal-close" onClick={() => {
              fieldsNames.forEach((name) => {
                setFieldValue(name, goal[name])
              })
              setModalOpen(false)
            }
          }>
            Close
          </a>
        </ModalHeader>
        <ModalBody>
          <div className="form-row">
            <div className="col">
              <NumberFormatField
                name="calories"
                label="Calories per Day"
                placeholder="Quantity"
                allowNegative={false}
                isAllowed={true}
                decimalSeparator={false}
              />
            </div>
            <div className="col">
              <NumberFormatField
                name="carbs"
                label="Carbs (g) per Day"
                placeholder="Quantity"
                allowNegative={false}
                isAllowed={true}
                decimalSeparator={false}
              />
            </div>
            <div className="col">
              <NumberFormatField
                name="fat"
                label="Fat (g) per day"
                placeholder="Quantity"
                allowNegative={false}
                isAllowed={true}
                decimalSeparator={false}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="col">
              <NumberFormatField
                name="protein"
                label="Protein (g) per day"
                placeholder="Quantity"
                allowNegative={false}
                isAllowed={true}
                decimalSeparator={false}
              />
            </div>
            <div className="col">
              <NumberFormatField
                name="water"
                label="Water intake (L) per day"
                placeholder="Quantity"
                allowNegative={false}
                isAllowed={true}
              />
            </div>
            <div className="col"></div>
          </div>

          <div className="form-action">
            <Button
              id=""
              type="submit"
              btnBlock=""
              btnSize=""
              color="primary"
              label="Save Goal"
              onClick={() => {
                let { calories, carbs, fat, protein, water } = values;
                if(calories && carbs && fat && protein && water){
                  let { calories, carbs, fat, protein, water } = errors;
                  if(calories || carbs || fat || protein || water){
                    makeFieldsTouched();
                  } else {
                    setModalOpen(false)
                  }
                } else { makeFieldsTouched(); }
              }}
            />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}


export default GoalNutritionAdd;
